// extracted by mini-css-extract-plugin
export default {"sectionSurvey":"Survey_sectionSurvey__XUmid","sectionSurveyTitle":"Survey_sectionSurveyTitle__2qkHr","sectionSurveyLink":"Survey_sectionSurveyLink__8qflj"};